import LoggerWrapper from './LoggerWrapper';
var logger;
export default (function (options) {
  if (!logger) {
    logger = new LoggerWrapper(options);
  }
  return logger;
});